import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { EditableItem } from './EditableItem'
import { Page } from '@/contexts/FlowNotesProvider'

interface GridCellProps {
  id: string
  row: any
  columnId: number
  content: string
  title: string
  onSave: (rowId: string, newContent: { title: string; content: string }) => void
  onDelete: () => void
  autoFocus: boolean
  currentPage: Page
}

const undeletableRowIds = new Set([
  //* Default / fallback rows
  'definitions',
  'analysis',
  'contentions',
  'value',
  'criterion',
  'resolution',

  //* Lincoln Douglas - Affirmative
  'aff-contention',

  //* Lincoln Douglas - Negative
  'value-clash',
  'neg-contention',
  'framework',
  'ks',

  //* Public Forum - Pro
  'pro-contention',
  'pro-warrants',
  'pro-impacts',

  //* Public Forum - Con
  'con-contention',
  'con-warrants',
  'con-impacts',

  //* Team Policy - Affirmative
  'advantages',
  'uniqueness',
  'impacts',
  'aff-contention',

  //* Team Policy - Negative
  'da',
  'cp',
  'kritiks',
  'topicality',
  'framework',
])

export const GridCell: React.FC<GridCellProps> = ({
  id,
  row,
  columnId,
  content,
  title,
  onSave,
  onDelete,
  autoFocus,
  currentPage,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} className="min-h-[100px]">
      <EditableItem
        content={content}
        title={title}
        onSave={(newContent) => onSave(row.id, newContent)}
        onDelete={onDelete}
        listeners={listeners}
        disableDelete={undeletableRowIds.has(row.id) && currentPage?.id === 'ai-judge-notes'}
        autoFocus={autoFocus}
      />
    </div>
  )
}
